import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/plugins/axios'

Vue.use(Vuex)

export default new Vuex.Store({
    namespace: true,
    state: {
      Sidebar_drawer: null,
      Customizer_draer: false,
      SidebarColor: '#eeeeee',
      SidebarBg: '',
      User: null,
      UserCan: null,
      ImpersonatingUser: JSON.parse(localStorage.getItem('ImpersonatingUser') || 'null'),

      Notification_drawer: false,
      Notifications: [],
    },


  mutations: {
    SET_SIDEBAR_DRAWER (state, payload) {
      state.Sidebar_drawer = payload
    },

    SET_CUSTOMIZER_DRAWER (state, payload) {
      state.Customizer_drawer = payload
    },

    SET_SIDEBAR_COLOR (state, payload) {
      state.SidebarColor = payload
    },

    SET_IMPERSONATING (state, staffMember) {
      state.ImpersonatingUser = staffMember
      // Persist across page refreshes
      if (staffMember) {
        localStorage.setItem('ImpersonatingUser', JSON.stringify(staffMember))
      } else {
        localStorage.removeItem('ImpersonatingUser')
      }
    },
  },

  actions: {
    getUser(context, payload){
      if(this.state.User) return this.state.User
      return axios.get('/api/user').then(res => {
        this.state.User = res.data
        return res.data
      })
    },

    getUserCan(context, payload){
      if(this.state.UserCan) return this.state.UserCan
      return axios.get('/api/current-user-can').then(res => {
        this.state.UserCan = res.data
        return res.data
      }).catch((err) => {
        return {}
      })
    },

  },
  // getters: {
  //   DrawerState(state) {
  //     return state.drawer;
  //   }
  // },

  // modules: {
  // }
})
